var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEvaluation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 105,
    viewBox: "0 0 141 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.5195 16.2205C82.4382 16.2205 82.3569 16.2205 82.3569 16.2205C74.957 6.50496 62.5968 0.101562 48.6102 0.101562C26.004 0.101562 7.78898 16.6621 7.78898 37.0499C7.78898 41.5396 8.68347 45.8822 10.3098 49.9303C7.54503 54.9352 6 60.6026 6 66.5644C6 87.3202 24.6216 104.102 47.4718 104.102C57.2298 104.102 66.2561 101.01 73.3306 95.9317C76.2581 96.5205 79.3481 96.8149 82.5195 96.8149C107.077 96.8149 127 78.7824 127 56.5545C127 34.253 107.077 16.2205 82.5195 16.2205Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M101.052 38.1378L103.738 40.8982V94.3195H45.779L43.7439 92.2898H100.319L101.052 38.1378Z",
    fill: "#D3D4D6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M100.319 40.8981H79.8052V19.0587H80.4564L81.1076 19.7082V37.8942H101.051L100.319 40.8981Z",
    fill: "#D3D4D6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2998 76.783L22.9047 79.381L34.0569 68.3396L35.1965 69.3138C35.2779 69.395 35.3593 69.395 35.3593 69.4762C35.3593 69.4762 35.4407 69.5574 35.6035 69.6386H35.6849L35.9292 69.8009C38.127 71.2623 40.6505 72.1554 43.2554 72.3989C44.0694 72.4801 44.8835 72.4801 45.6975 72.3989C53.9192 71.8306 60.35 65.0109 60.35 56.811C60.35 48.611 53.9192 41.7101 45.6975 41.223C44.8021 41.1418 43.988 41.1418 43.2554 41.223C35.1151 41.9537 29.0099 48.611 29.0099 56.811C29.0099 60.1396 30.1495 62.8188 30.8008 64.1178C30.8822 64.2802 30.9636 64.4426 30.9636 64.4426L31.6148 65.5792L30.7194 66.4723L20.2998 76.783Z",
    fill: "#D3D4D6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9424 50.6406L42.9298 62.4127C42.6856 62.6563 42.36 62.8187 42.0344 62.8998H41.953C41.6274 62.8998 41.3018 62.8187 41.0576 62.5751L35.3594 57.4603",
    fill: "#D3D4D6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4858 75.1593L22.0907 77.7573L33.2429 66.7158L34.3826 67.69C34.464 67.7712 34.5454 67.7712 34.5454 67.8524C34.5454 67.8524 34.6268 67.9336 34.7896 68.0148H34.871L35.1152 68.1772C37.3131 69.6385 39.8366 70.5316 42.4414 70.7752C43.2555 70.8563 44.0695 70.8563 44.8835 70.7752C53.1052 70.2068 59.536 63.3871 59.536 55.1872C59.536 46.9873 53.1052 40.0863 44.8835 39.5992C43.9881 39.518 43.1741 39.518 42.4414 39.5992C34.3012 40.3299 28.1959 46.9873 28.1959 55.1872C28.1959 58.5159 29.3356 61.195 29.9868 62.494C30.0682 62.6564 30.1496 62.8188 30.1496 62.8188L30.8008 63.9554L29.9054 64.8485L19.4858 75.1593Z",
    fill: "#B29A6A",
    stroke: "#6C6C6C",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3137 33.9972V18.8152H81.2706L100.644 38.1378C100.644 38.1378 100.97 92.5333 100.644 92.2086C100.319 91.8838 44.1509 92.2086 44.1509 92.2086V76.6206",
    stroke: "#6C6C6C",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7685 64.8241C59.1092 59.4977 59.1092 50.8617 53.7685 45.5352C48.4279 40.2087 39.769 40.2087 34.4284 45.5352C29.0877 50.8617 29.0877 59.4977 34.4284 64.8241C39.769 70.1506 48.4279 70.1506 53.7685 64.8241Z",
    fill: "white",
    stroke: "#6C6C6C",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1892 18.8152V37.9753H100.644",
    stroke: "#6C6C6C",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1284 49.0168L42.1159 60.7891C41.8717 61.0327 41.5461 61.1951 41.2204 61.2762H41.139C40.8134 61.2762 40.4878 61.1951 40.2436 60.9515L34.5454 55.8366",
    stroke: "#6C6C6C",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0137 49.6665H93.9693",
    stroke: "#6C6C6C",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1541 57.1357H93.9694",
    stroke: "#6C6C6C",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0137 64.686H93.9693",
    stroke: "#6C6C6C",
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2944 79.7058H93.9695",
    stroke: "#6C6C6C",
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1728 68.177L22.7419 74.672",
    stroke: "#6C6C6C",
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvaluation);
export default __webpack_public_path__ + "static/media/evaluation.bcc549a0.svg";
export { ForwardRef as ReactComponent };